import Autocomplete, {
  type AutocompleteInputChangeReason,
} from '@mui/material/Autocomplete';
import type { SyntheticEvent } from 'react';
import { ItemWithLabel } from '../utils';
import { TextField } from './index';
import { TextFieldProps } from './TextField';

export function TextAutocompleteField({
  name,
  options,
  onChange,
  value,
  ...rest
}: TextAutocompleteFieldProps) {
  const normalizedOptions = Array.isArray(options) ? options : [];

  const selectedTags = new Set(
    ((value as any) || '')
      .split(',')
      .map((tag: string) => tag.trim().toLowerCase())
      .filter(Boolean),
  );

  const selectedOption =
    normalizedOptions.find((option) => {
      return selectedTags.has((option.value || '').toLowerCase());
    }) || null;

  function onAutocompleteChange(event: SyntheticEvent, option: unknown) {
    const val = (option as ItemWithLabel | undefined)?.value || '';

    onChange?.({
      ...event,
      target: { ...event.target, name, value: val },
    } as any);
  }

  function onInputChange(
    event: SyntheticEvent,
    _option: unknown,
    reason: AutocompleteInputChangeReason,
  ) {
    if (reason === 'clear') {
      onChange?.({
        ...event,
        target: { ...event.target, name, value: '' },
      } as any);
    }
  }

  return (
    <Autocomplete
      freeSolo
      getOptionLabel={(option) => option.label as string}
      ListboxProps={{ name } as any}
      onChange={onAutocompleteChange}
      onInputChange={onInputChange}
      options={normalizedOptions}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          onChange={onChange}
          value={value}
          {...rest}
        />
      )}
      value={selectedOption as any}
    />
  );
}

export type TextAutocompleteFieldProps = {
  options: ItemWithLabel[];
} & TextFieldProps;
